import { Trans } from 'react-i18next';
import LOCALS from 'commons/locals';
import { getUmsMemberMailList } from 'apis/ums';
import { useEffect, useState } from 'react';
import { UmsMemberMail } from 'types/ums';
import i18n from 'i18n';
import { Button, Modal, Table, Card } from 'antd';
import DualTimezoneTime from 'components/dual-timezone-time';
import { Mail } from 'lucide-react';
import DOMPurify from 'dompurify';

const OrderEmailHistory = ({
  orderId,
  stockPlace,
}: {
  orderId: number;
  stockPlace?: string;
}) => {
  const [pageNum] = useState(1);
  const [pageSize] = useState(100);
  const [data, setData] = useState<UmsMemberMail[]>([]);
  const [content, setContent] = useState('');

  useEffect(() => {
    getUmsMemberMailList({ orderId, pageNum, pageSize }).then((res) => {
      setData(res.list);
    });
  }, [orderId, pageNum, pageSize]);

  const columns = [
    {
      title: i18n.t(LOCALS.subject),
      key: 'subject',
      dataIndex: 'subject',
    },
    {
      title: i18n.t(LOCALS.content),
      key: 'content',
      dataIndex: 'content',
      render: (content: UmsMemberMail['content']) => {
        return (
          <Button
            type="link"
            onClick={() => {
              setContent(content);
            }}
          >
            {i18n.t(LOCALS.view)}
          </Button>
        );
      },
    },
    {
      title: i18n.t(LOCALS.send_time),
      dataIndex: 'sendTime',
      key: 'sendTime',
      render: (sendTime: UmsMemberMail['sendTime']) => {
        return <DualTimezoneTime time={sendTime} stockPlace={stockPlace} />;
      },
    },
  ];

  if (data.length === 0) return null;

  return (
    <Card bodyStyle={{ padding: '16px' }}>
      <div className="flex items-center gap-2 mb-4 text-base font-medium">
        <Mail className="w-5 h-5" />
        <Trans i18nKey={LOCALS.email_history} />
      </div>

      <Modal
        open={!!content}
        onCancel={() => {
          setContent('');
        }}
      >
        <p
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
        ></p>
      </Modal>

      <Table
        rowKey="id"
        tableLayout="auto"
        scroll={{ x: 'max-content' }}
        columns={columns}
        dataSource={data}
        pagination={false}
        bordered
        size="small"
      />
    </Card>
  );
};

export default OrderEmailHistory;
